import { VStack, Text, Stack, HStack, Image, Circle } from '@chakra-ui/react';
import { i_20_12, i_24_12, i_24_16, i_28, i_h4 } from '../../../../style';
import '../../Home.css';

const HomePiece2: React.FC = () => {
    return (
        <VStack w="100%" spacing="58px" pl="23px" pr="18px">
            <VStack className={i_24_16} textAlign="center" color="#62F9F9" spacing="0px">
                <Text>Providing liquidity in Shared Liquidity Box</Text>
                <Text>Using the liquidity in original chain to farm on multi-chains</Text>
            </VStack>

            <Stack
                bg="rgba(255, 255, 255, 0.09)"
                border="1px dashed #2BF2FF"
                borderRadius="20px"
                py={{ base: '26px', sm: '52px' }}
                px={{ base: '22px', sm: '40px' }}
                spacing={{ base: '19px', sm: '31px' }}
            >
                <HStack spacing="15px">
                    <Circle w="12px" h="12px" bg="#01FBFB"></Circle>
                    <Text className={i_20_12} color="#62F9F9">
                        Which solved two main headaches for bridging liquidity
                    </Text>
                </HStack>

                <Stack direction={{ base: 'column', sm: 'row' }} spacing={{ base: '17px', sm: '44px' }}>
                    <Stack
                        w={{ base: '100%', sm: '360px' }}
                        h={{ base: '88px', sm: '181px' }}
                        color="#161616"
                        bg="linear-gradient(108.78deg, #00FFFF -11.99%, #00EBEB 112.03%)"
                        borderRadius="10px"
                        p={{ base: '13px', sm: '50px' }}
                        px={{ base: '32px', sm: '50px' }}
                        spacing={{ base: '6px', sm: '9px' }}
                    >
                        <HStack spacing="20px">
                            <Image src="/assets/home/homePiece2/safety.svg" fallbackSrc="/assets/home/homePiece2/safety.svg"></Image>
                            <Text className={i_28}>Safety</Text>
                        </HStack>
                        <Text className={i_h4}>get rugged/be hacked</Text>
                    </Stack>
                    <Stack
                        w={{ base: '100%', sm: '429px' }}
                        h={{ base: '88px', sm: '181px' }}
                        color="#161616"
                        bg="linear-gradient(108.78deg, #00FFFF -11.99%, #00EBEB 112.03%)"
                        borderRadius="10px"
                        p={{ base: '13px', sm: '50px' }}
                        px={{ base: '32px', sm: '50px' }}
                        spacing={{ base: '6px', sm: '9px' }}
                    >
                        <HStack spacing="20px">
                            <Image
                                src="/assets/home/homePiece2/Inefficiency.svg"
                                fallbackSrc="/assets/home/homePiece2/Inefficiency.svg"
                            ></Image>
                            <Text className={i_28}>Inefficiency</Text>
                        </HStack>
                        <Text className={i_h4}>Idle liquidity on the bridge treasury</Text>
                    </Stack>
                </Stack>
            </Stack>
        </VStack>
    );
};

export default HomePiece2;
